export const transformEnum = (name: string) =>
  name
    .replace(/[^\w\s]|_/g, '')
    .replace(/\s+/g, '_')
    .toUpperCase();
